import { useTranslation } from 'react-i18next';

import { KebabMenu } from '~/components/KebabMenu';

type ListLabelActionsProps = {
  onEditClick: () => void;
  onDeleteClick: () => void;
};

export const ListLabelActions = ({
  onEditClick,
  onDeleteClick,
}: ListLabelActionsProps) => {
  const { t } = useTranslation('settings', { keyPrefix: 'label' });

  return (
    <KebabMenu>
      <KebabMenu.Item
        onClick={(e) => {
          e.stopPropagation();
          onEditClick();
        }}
      >
        {t('list.editButton')}
      </KebabMenu.Item>
      <KebabMenu.Item
        state="error"
        onClick={(e) => {
          e.stopPropagation();
          onDeleteClick();
        }}
      >
        {t('list.deleteButton')}
      </KebabMenu.Item>
    </KebabMenu>
  );
};

ListLabelActions.displayName = 'ListLabelActions';
